import Util from '../utils/util';
const isTest = Util.isTestEnvironment() // 是测试环境

const nullResourceId = '000000000000000000'

const resourceIdsMap = {
    // 常规文章页-推荐阅读
    normalRecFeed: { 
        test: {
            productId: 1346,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10457","rule":1,"fixArray":[1,2,4,9,14,19,24,29,34,39]}
        },
        prod: {
            productId: 1475,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d',
            adInfo: {
                posCode: "10102",
                rule: 1,
                fixArray: [1,2,4,9,14,19,24,29,34,39]
            }
        }
    },
    // 微信
    wxRecFeed: { 
        test: {
            productId: 1346,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10457","rule":1,"fixArray":[3]}
        },
        prod: {
            productId: 1475,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d',
            adInfo: {
                posCode: "10102",
                rule: 1,
                fixArray: [3]
            }
        }
    },
    // 编辑精选流
    normalSpecialRecFeed: { 
        test: {
            productId: 1566,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d-special',
            adInfo: {"posCode":"10457","rule":1,"fixArray":[1,2,4,9,14,19,24,29,34,39]}
        },
        prod: {
            productId: 7744,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d-special',
            adInfo: {
                posCode: "10102",
                rule: 1,
                fixArray: [1,2,4,9,14,19,24,29,34,39]
            }
        }
    },
    // 国际新闻流
    normalInternationalRecFeed: { 
        test: {
            productId: 1583,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d-international',
            adInfo: {"posCode":"10457","rule":1,"fixArray":[1,2,4,9,14,19,24,29,34,39]}
        },
        prod: {
            productId: 1980,
            productType: 13,
            resourceId: '903243720214904836',
            spmCCode: 'fd-d-international',
            adInfo: {
                posCode: "10102",
                rule: 1,
                fixArray: [1,2,4,9,14,19,24,29,34,39]
            }
        }
    },
    // 深度文章页-推荐阅读
    deepRecFeed: { 
        test: {
            productId: 1980,
            productType: 13,
            resourceId: '',
            spmCCode: 'fd-d',
            adInfo: {},
            view: "excerptTagsMode",
        },
        prod: {
            productId: 7928,
            productType: 13,
            resourceId: '',
            spmCCode: 'fd-d',
            adInfo: {},
            view: "excerptTagsMode",
        }
    },
    // wcms-推荐阅读
    wcmsRecFeed: {
        test: {
            productId: 1142,
            productType: 13,
            resourceId: '1054527905583005696',
            spmCCode: 'fd-d',
            adInfo:{"posCode":"10441","rule":1,"fixArray":[1,2,4,9,14,19,24,29,34,39]}
        },
        prod: {
            productId: 2010,
            productType: 13,
            resourceId: '1054527905583005696',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10279","rule":1,"fixArray":[1,2,4,9,14,19,24,29,34,39]}
        }
    },
    // 黑鲨|最美天气文章页-推荐阅读
    heishaRecFeed: {
        test: {
            productId: 1142,
            productType: 13,
            resourceId: '903243720214904835',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10448","rule":2,"turn":3,"number":1,"begin":3}
        },
        prod: {
            productId: 7964,
            productType: 13,
            resourceId: '903243720214904835',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10119","rule":2,"turn":3,"number":1,"begin":3}
        }
    },
    // 黄历天气-推荐阅读
    hltqRecFeed: {
        test: {
            productId: 1142,
            productType: 13,
            resourceId: '903243720214904834',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10447","rule":2,"turn":3,"number":1,"begin":3}
        },
        prod: {
            productId: 1381,
            productType: 13,
            resourceId: '903243720214904834',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10121","rule":2,"turn":3,"number":1,"begin":3}
        }
    },
    // 花生地铁-推荐阅读
    hsdtRecFeed: {
        test: {
            productId: 1380,
            productType: 13,
            resourceId: '903243720214904833',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10449","rule":2,"turn":3,"number":1,"begin":3}
        },
        prod: {
            productId: 1380,
            productType: 13,
            resourceId: '903243720214904833',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10118","rule":2,"turn":3,"number":1,"begin":3}
        }
    },
    // vivo-推荐阅读
    vivoRecFeed: {
        test: {
            productId: 1142,
            productType: 13,
            resourceId: nullResourceId,
            adInfo: {},
            spmCCode: 'fd-d'
        },
        prod: {
            productId: 1382,
            productType: 13,
            resourceId: nullResourceId,
            adInfo: {},
            spmCCode: 'fd-d'
        }
    },
    // 网站地图
    navmap: {
        test: {
            productId: 350,
            productType: 14,
            resourceId: nullResourceId,
            adInfo: {},
            spmCCode: 'navMap'
        },
        prod: {
            productId: 585,
            productType: 14,
            resourceId: nullResourceId,
            adInfo: {},
            spmCCode: 'navMap'
        }
    },
    // 全站导航
    allNavMap: {
        test: [
            {
                productId: 347,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'regularNavList'
            },
            {
                productId: 350,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'recWonderfulList'
            },
            {
                productId: 348,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'anchorNavList'
            },
            {
                productId: 349,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'recMoreList'
            },   
        ],
        prod: [ 
            {
                productId: 401,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'regularNavList'
            },
            {
                productId: 402,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'recWonderfulList'
            },
            {
                productId: 403,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'anchorNavList'
            },
            {
                productId: 404,
                productType: 14,
                resourceId: nullResourceId,
                adInfo: {},
                spmCCode: 'navbar',
                tplCompKey: 'recMoreList'
            },   
        ]
    },
    // 视频文章页-相关推荐
    videoArticleRecommend: {
        test: {
            productId: 1557,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'fd-d',
            adInfo: {}
        },
        prod: {
            productId: 1557,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'fd-d',
            adInfo: {}
        }
    },
    // 图集页-推荐图集
    pictureRecAlbum: {
        test: {
            productId: 1747,
            productType: 13,
            resourceId: '903243720214904844',
            spmCCode: 'rec',
            adInfo: {"posCode":"10478","rule":1,"fixArray":[2]}
        },
        prod: {
            productId: 1577,
            productType: 13,
            resourceId: '903243720214904844',
            spmCCode: 'rec',
            adInfo: {"posCode":"10163","rule":1,"fixArray":[2]}
        }
    },
    // 图集页-图集热榜
    pictureHotRec: {
        test: {
            productId: 1747,
            productType: 13,
            resourceId: '903243720214904845',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10480","rule":2,"turn":"7","number":"1","begin":"4"}
        },
        prod: {
            productId: 1578,
            productType: 13,
            resourceId: '903243720214904845',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10164","rule":2,"turn":"7","number":"1","begin":"4"}
        }
    },
    // 讨论+视野混合流
    discussVisionRec: {
        test: {
            productId: 6201,
            productType: 104,
            resourceId: '',
            spmCCode: 'Comments',
            adInfo: {}
        },
        prod: {
            productId: 6201,
            productType: 104,
            resourceId: '',
            spmCCode: 'Comments',
            adInfo: {}
        }
    }
}
// 根据senceKey获取奥丁请求参数
const getOdinResourceIdMap = (senceKey)=>{
    return resourceIdsMap?.[senceKey]?.[isTest ? 'test':'prod']
}

export {
    getOdinResourceIdMap,
    nullResourceId, // 空resourceId定义值，本意是不请求广告或返回纯流（https://www.tapd.cn/50690310/prong/stories/view/1150690310001040149）
}